require('./article-slider');